export interface ActivityType {
    value: string;
    label: string;
}

export const ACTIVITY_TYPES: ActivityType[] = [
    { value: 'sur-site', label: '🏢 Sur site' },
    { value: 'teletravail', label: '🏠 Télétravail/Flex Office' },
    { value: 'recup-hs', label: '⏰ Récup HS' },
    { value: 'cp', label: '🏖️ CP' },
    { value: 'rtt', label: '🎯 RTT' },
    { value: 'recup-forfait', label: '📋 Récup forfait jour' },
    { value: 'maladie', label: '🏥 Maladie' },
    { value: 'temps-partiel', label: '⏲️ Temps partiel' },
    { value: 'jour-non-travaille', label: '🚫 Jour non travaillé' },
    { value: 'ecole', label: '🎓 École' },
    { value: 'rdv-client', label: '👥 RDV client/Déplacement' },
    { value: 'jour-ferie', label: '🎉 Jour férié' },
    { value: 'formation', label: '📚 Formation' },
    { value: 'absence', label: '❌ Absence' },
    { value: 'week-end', label: '📅 Week-end' }
];
